(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    function initEmailSignupFeedback(root) {
    var scope = root || document;
    var blocks = scope.querySelectorAll('.email-signup-block');

    blocks.forEach(function (block) {
      if (block.dataset.emailSignupFeedbackInitialized === 'true') return;
      block.dataset.emailSignupFeedbackInitialized = 'true';

      var form = block.querySelector('form.email-signup__form');
      var emailInput = form ? form.querySelector('input[name="contact[email]"]') : null;
      var loadingOverlay = block.querySelector('[data-email-signup-loading]');
      var successFlag = block.querySelector('[data-email-signup-success="true"]');
      var successModal = block.querySelector('[data-email-signup-success-modal]');
      if (loadingOverlay && loadingOverlay.parentElement !== document.body) {
        document.body.appendChild(loadingOverlay);
      }

      if (successModal && successModal.parentElement !== document.body) {
        document.body.appendChild(successModal);
      }

      var successDialog = successModal ? successModal.querySelector('.email-signup-success-modal__dialog') : null;

      var closeButtons = successModal ? successModal.querySelectorAll('[data-email-signup-success-close]') : [];

      function updateBodyLock() {
        var hasOpenLayer = document.querySelector(
          '[data-email-signup-loading]:not([hidden]), [data-email-signup-success-modal]:not([hidden])'
        );

        if (hasOpenLayer) {
          document.body.classList.add('email-signup-modal-open');
        } else {
          document.body.classList.remove('email-signup-modal-open');
        }
      }

      function openLoading() {
        if (!loadingOverlay) return;

        loadingOverlay.hidden = false;
        updateBodyLock();
      }

      function openSuccessModal() {
        if (!successModal) return;

        successModal.hidden = false;
        updateBodyLock();

        if (successDialog) {
          setTimeout(function () {
            successDialog.focus();
          }, 50);
        }
      }

      function closeSuccessModal() {
        if (!successModal) return;

        successModal.hidden = true;
        updateBodyLock();
      }

      if (form && emailInput) {
        form.addEventListener('submit', function () {
          if (form.checkValidity && !form.checkValidity()) return;

          openLoading();
        });
      }

      var customerPosted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';

      if ((successFlag || customerPosted) && successModal) {
        if (loadingOverlay) {
          loadingOverlay.hidden = true;
        }

        openSuccessModal();
      }

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeSuccessModal);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initEmailSignupFeedback(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initEmailSignupFeedback(event.target);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var openModals = document.querySelectorAll('[data-email-signup-success-modal]:not([hidden])');

    openModals.forEach(function (modal) {
      modal.hidden = true;
    });

    var hasOpenLayer = document.querySelector(
      '[data-email-signup-loading]:not([hidden]), [data-email-signup-success-modal]:not([hidden])'
    );

    if (!hasOpenLayer) {
      document.body.classList.remove('email-signup-modal-open');
    }
  });

  window.addEventListener('pageshow', function () {
    var loadingOverlays = document.querySelectorAll('[data-email-signup-loading]');

    loadingOverlays.forEach(function (overlay) {
      overlay.hidden = true;
    });

    var hasOpenModal = document.querySelector('[data-email-signup-success-modal]:not([hidden])');

    if (!hasOpenModal) {
      document.body.classList.remove('email-signup-modal-open');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
